const createFetchival = require('./create-fetchival')

module.exports = createFetchival()
